module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-component'), _vm._v(" "), _c('frame-header'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container g-mt-10 g-mb-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-1 col-md-1 col-sm-12 col-xs-12 text-center"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
  }, [_c('button', {
    staticClass: "btn g-bg-main g-bg-main-blue--hover g-color-white text-uppercase g-rounded-10 mar-right-10",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "disabled": !_vm.Account.isFrameKitAllowed,
      "id": "PlaceOrder"
    },
    on: {
      "click": function($event) {
        return _vm.ToggleFrameOrderForm('Order Frame Kit')
      }
    }
  }, [_vm._v("\n            Order Collection\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-bg-main g-bg-main-blue--hover g-color-white g-rounded-10 mar-right-10",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "disabled": !_vm.Account.isFrameOrderingAllowed,
      "data-balloon": _vm.GetTooltip(_vm.Account.isFrameOrderingAllowed),
      "data-balloon-pos": "up"
    },
    on: {
      "click": function($event) {
        return _vm.ToggleFrameOrderForm('Order Individual Frame')
      }
    }
  }, [_c('span', {
    staticClass: "text-uppercase"
  }, [_vm._v("Order Replacement")])]), _vm._v(" "), _c('button', {
    staticClass: "btn g-bg-main g-bg-main-blue--hover g-color-white g-rounded-10 mar-right-10",
    staticStyle: {
      "margin-bottom": "20px"
    },
    on: {
      "click": _vm.goToVirtualTryOn
    }
  }, [_c('span', {
    staticClass: "text-uppercase"
  }, [_vm._v("Virtual Try-On")])]), _vm._v(" "), (_vm.ShowDisplayCaseField) ? _c('button', {
    staticClass: "btn g-bg-main g-bg-main-blue--hover g-color-white g-rounded-10 mar-right-10",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "disabled": !_vm.Account.isFrameOrderingAllowed,
      "data-balloon": _vm.GetTooltip(_vm.Account.isFrameOrderingAllowed),
      "data-balloon-pos": "up"
    },
    on: {
      "click": function($event) {
        return _vm.ToggleFrameOrderForm('Order Display Case')
      }
    }
  }, [_c('span', {
    staticClass: "text-uppercase"
  }, [_vm._v("Order Display Case")])]) : _vm._e()]), _vm._v(" "), (!_vm.isFrameLoading) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('frame-filters', {
    attrs: {
      "searchValues": _vm.searchValues
    },
    on: {
      "clicked": _vm.GetFrames,
      "reset": function($event) {
        return _vm.Reset()
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.isFrameLoading) ? _c('page-loader') : _vm._e()], 1)]), _vm._v(" "), _vm._l((_vm.frameInformationList), function(frameInformation, index) {
    return (frameInformation.isEVFFrame && !_vm.isFrameLoading) ? _c('div', {
      key: index,
      staticClass: "container-fluid g-pb-40"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-2 col-md-2 col-sm-12 col-xs-12 text-center"
    }, [_c('frame-order-collection')], 1), _vm._v(" "), (frameInformation.frameList.length > 0) ? _c('div', {
      staticClass: "col-lg-8 col-md-9 col-sm-12 col-xs-12"
    }, [_c('frame-list', {
      attrs: {
        "frameList": frameInformation.frameList
      }
    })], 1) : _c('div', {
      staticClass: "col-lg-8 col-md-9 col-sm-12 col-xs-12 center div-spacing-top"
    }, [_c('p', {
      staticClass: "g-font-size-20 g-color-main"
    }, [_vm._v("\n            Your search returned no results\n          ")])]), _vm._v(" "), (!_vm.Account.isFrameKitAllowed) ? _c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('p', {
      staticClass: "error-message"
    }, [_vm._v("\n            You cannot place an order for a frame collection at this time\n          ")])]) : _vm._e()]), _vm._v(" "), (!_vm.isFrameLoading) ? _c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    })]) : _vm._e(), _vm._v(" "), (_vm.isFrameLoading) ? _c('page-loader') : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), (
    _vm.frameInformationList.filter(function (a) { return !a.isEVFFrame; }).length > 0 &&
    !_vm.isFrameLoading
  ) ? _c('div', {
    staticClass: "container-fluid g-pb-40"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.showJotForm) ? _c('jotform-modal', {
    attrs: {
      "Account": _vm.Account,
      "formID": "220894492083058"
    },
    on: {
      "closeJotForm": _vm.CloseModal
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.frameInformationList.filter(
    function (a) { return !a.isEVFFrame; }
  )), function(frameInformation, index) {
    return (!frameInformation.isEVFFrame && !_vm.isFrameLoading) ? _c('div', {
      key: index,
      staticClass: "container-fluid g-pb-40"
    }, [_c('div', {
      staticClass: "row"
    }, [(index != 0) ? _c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
    }, [_c('hr')]) : _vm._e(), _vm._v(" "), (frameInformation.catalogName) ? _c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
    }, [_c('h2', [_vm._v(_vm._s(_vm.ConvertToTitleCase(frameInformation.catalogName)))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-2 col-sm-12 col-xs-12 text-center"
    }), _vm._v(" "), (frameInformation.frameList.length > 0) ? _c('div', {
      staticClass: "col-lg-8 col-md-9 col-sm-12 col-xs-12"
    }, [_c('frame-list', {
      attrs: {
        "frameList": frameInformation.frameList
      }
    })], 1) : _vm._e()])]) : _vm._e()
  })], 2), _vm._v(" "), _c('footer-component'), _vm._v(" "), (_vm.isPlaceOrder) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('frame-shipping-billing', {
    attrs: {
      "Account": _vm.Account
    },
    on: {
      "exitModal": _vm.CloseModal
    }
  })], 1)])])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
  }, [_c('h2', [_vm._v("Frame Collection")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('p', [_vm._v("\n            View the Champions for Sight® frame collection below. Once ordered, the collection will arrive in 2-3 weeks, and you can begin ordering complete pairs of glasses for eligible patients without the need to ship frames to the lab. \n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            ✨ New! Our Virtual Try-On tool lets patients see themselves in any of the 45 stylish frame styles — in real time and true to fit.\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
  }, [_c('h1', [_vm._v("Additional Frames")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-12 col-xs-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12"
  }, [_c('p', [_vm._v("\n                These frames are not part of the Changing Life through Lenses™\n                frame collection, but are available for you to select as a\n                Frame and Lens order on the Order page. You cannot order a\n                frame collection for these\n                additional frames.\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-12 col-xs-12"
  })])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-72b93eda", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72b93eda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/frameResources/FramesCenter.vue
// module id = 542
// module chunks = 4